(() => {
  if (customElements.get('card-mobile-gallery')) return;

  class CardMobileGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-card-mobile-gallery-track]');
      this.dots = Array.from(this.querySelectorAll('[data-card-mobile-gallery-dot]'));

      if (!this.track || this.dots.length < 2) return;

      this.updateActiveDot = this.updateActiveDot.bind(this);
      this.noteTouchStart = this.noteTouchStart.bind(this);
      this.preventSwipeClick = this.preventSwipeClick.bind(this);
      this.track.addEventListener('scroll', this.updateActiveDot, { passive: true });
      this.track.addEventListener('touchstart', this.noteTouchStart, { passive: true });
      this.track.addEventListener('click', this.preventSwipeClick, true);
      window.addEventListener('resize', this.updateActiveDot);
      this.updateActiveDot();
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this.updateActiveDot);
        this.track.removeEventListener('touchstart', this.noteTouchStart);
        this.track.removeEventListener('click', this.preventSwipeClick, true);
      }
      window.removeEventListener('resize', this.updateActiveDot);
    }

    noteTouchStart() {
      this.touchStartScrollLeft = this.track.scrollLeft;
    }

    preventSwipeClick(event) {
      if (Math.abs(this.track.scrollLeft - (this.touchStartScrollLeft || 0)) < 8) return;

      event.preventDefault();
      event.stopPropagation();
    }

    updateActiveDot() {
      const slideWidth = this.track.clientWidth || 1;
      const activeIndex = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.track.scrollLeft / slideWidth)));

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }
  }

  customElements.define('card-mobile-gallery', CardMobileGallery);
})();
